import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, Mail, MailOpen, Phone, MapPin } from "lucide-react";
import { api, errMsg } from "@/lib/api";

export const AdminInquiries = ({ onChange }) => {
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/inquiries").then((r) => setItems(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, []);
  const toggle = async (i) => { await api.patch(`/admin/inquiries/${i.id}`, { read: !i.read }); await load(); onChange?.(); };
  const remove = async (id) => { if (!window.confirm("¿Eliminar esta consulta?")) return; await api.delete(`/admin/inquiries/${id}`); await load(); onChange?.(); };

  if (!items.length) return <p className="text-[#5C635E]" data-testid="admin-inquiries-empty">Todavía no llegaron consultas.</p>;
  return (
    <ul className="space-y-3" data-testid="admin-inquiries">
      {items.map((i) => (
        <li key={i.id} data-testid={`admin-inquiry-item-${i.id}`} className={`card-fv p-5 border-l-4 ${i.read ? "border-l-stone-200" : "border-l-[#8B2B22]"}`}>
          <div className="flex flex-wrap items-start justify-between gap-3">
            <div>
              <p className="font-semibold flex items-center gap-2">{i.name}
                {!i.read && <span className="rounded-full bg-[#8B2B22] px-2 text-[10px] uppercase tracking-wider text-white" data-testid={`admin-inquiry-unread-${i.id}`}>Nueva</span>}
              </p>
              <p className="mt-1 flex flex-wrap gap-x-4 gap-y-1 text-sm text-[#5C635E]">
                <a href={`mailto:${i.email}`} className="hover:text-[#8B2B22]">{i.email}</a>
                {i.phone && <span className="flex items-center gap-1"><Phone size={13} />{i.phone}</span>}
                {i.location && <span className="flex items-center gap-1"><MapPin size={13} />{i.location}</span>}
              </p>
            </div>
            <div className="flex items-center gap-1 text-xs text-[#5C635E]">
              {new Date(i.created_at).toLocaleString("es-AR")}
              <button onClick={() => toggle(i)} className="ml-2 p-2 hover:bg-stone-100" data-testid={`admin-inquiry-toggle-${i.id}`} title={i.read ? "Marcar como no leída" : "Marcar como leída"}>
                {i.read ? <Mail size={16} /> : <MailOpen size={16} />}
              </button>
              <button onClick={() => remove(i.id)} className="p-2 text-red-700 hover:bg-red-50" data-testid={`admin-inquiry-delete-${i.id}`} aria-label="Eliminar"><Trash2 size={16} /></button>
            </div>
          </div>
          <p className="mt-3 whitespace-pre-line text-sm leading-relaxed">{i.message}</p>
        </li>
      ))}
    </ul>
  );
};
